import { NgModule } from '@angular/core';
import * as fromUED from './store/reducer';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserEntryDatesEffects } from './store/effects';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule, DropdownModule } from '../shared/efaact-primeng.module';
import { SharedModule } from '../shared/shared.module';
import { UserentrydatesFeaturesComponent } from './features/userentrydates-features.component';
import { UserentrydatesPresentersComponent } from './presenters/userentrydates-presenters.component';

@NgModule({
  imports: [
    CommonModule
    , StoreModule.forFeature('entrydates', fromUED.reducer)
    , EffectsModule.forFeature([UserEntryDatesEffects])
    , EfaactMaterialModule
    , FormsModule
    , ReactiveFormsModule
    , MultiSelectModule
    , DropdownModule
    , SharedModule
  ],
  declarations: [UserentrydatesFeaturesComponent, UserentrydatesPresentersComponent],
})
export class UserEntryDatesModule { }
